<template>
  <div id="root"
       :data-endpoint-catalogue="dataEndpointCatalogue"
       :data-endpoint-labels="dataEndpointLabels"
       :data-endpoint-listing="dataEndpointListing"
       :data-endpoint-products="dataEndpointProducts"
       :data-endpoint-videos="dataEndpointVideos"
       :data-endpoint-interactive-main="dataEndpointInteractiveMain">
    <ui-interface v-if="areLabelsLoaded"></ui-interface>
    <tilt-phone v-if="!isPhoneLandscape && areLabelsLoaded"></tilt-phone>
    <router-view v-if="isPhoneLandscape && areLabelsLoaded"></router-view>
    <app-footer v-if="areLabelsLoaded"></app-footer>
  </div>
</template>

<script>
  import Footer from './components/Footer'
  import Interface from './components/Interface'
  import TiltPhone from './components/TiltPhone'

  export default {
    data () {
      return {
        initApp: false,
        dataEndpointCatalogue: '',
        dataEndpointLabels: '',
        dataEndpointListing: '',
        dataEndpointProducts: '',
        dataEndpointVideos: '',
        dataEndpointInteractiveMain: '',
        areLabelsLoaded: false
      }
    },
    components: {
      'app-footer': Footer,
      'ui-interface': Interface,
      'tilt-phone': TiltPhone
    },
    computed: {
      isPhoneLandscape(){
        return this.$store.state.isPhoneLandscape;
      }
    },
    methods: {

      /*
      checkBetaVersion(){
        var vm = this;
        var lang = vm.$route.params.lang;
        var href;
        if(lang){
          ENV.lang = lang;
        }
        if(ENV.lang == 'en'){
          href = 'http://www.iguzzini.com/news/the-light-experience-goes-digital/';
        }
        else if(ENV.lang == 'it'){
          href = 'http://www.iguzzini.com/it/notizie/the-light-experience-goes-digital/';
        }
        document.querySelector('.beta-version').setAttribute('href', href);
      },
      */

      checkDeviceOrientation(){
        var root = document.querySelector('body');

        setTimeout(function () {
          window.scrollTo(0, 10);
        }, 1);

        ENV.interactive = document.querySelector('#root').getAttribute('data-endpoint-interactive-main');

        /*
        if (window.matchMedia("(orientation: portrait)").matches) {
          root.classList = 'is-portrait';
          if (window.innerWidth < 768) {
            this.$store.state.isPhoneLandscape = false;
          }
          else {
            this.$store.state.isPhoneLandscape = true;
          }
        }
        if (window.matchMedia("(orientation: landscape)").matches) {
          root.classList = 'is-landscape';
          this.$store.state.isPhoneLandscape = true;
        }
        */

        if (document.documentElement.clientHeight > document.documentElement.clientWidth) {
          root.classList = 'is-portrait';
          this.$store.state.isPhoneLandscape = window.innerWidth >= 768;
        }
        else {
          root.classList = 'is-landscape';
          this.$store.state.isPhoneLandscape = true;
        }
      }
    },
    created(){
      var vm = this;

      //Bind endpoints to app
      this.dataEndpointCatalogue = document.querySelector('#root').getAttribute('data-endpoint-catalogue');
      this.dataEndpointLabels = document.querySelector('#root').getAttribute('data-endpoint-labels');
      this.dataEndpointListing = document.querySelector('#root').getAttribute('data-endpoint-listing');
      this.dataEndpointProducts = document.querySelector('#root').getAttribute('data-endpoint-products');
      this.dataEndpointVideos = document.querySelector('#root').getAttribute('data-endpoint-videos');
      this.dataEndpointInteractiveMain = document.querySelector('#root').getAttribute('data-endpoint-interactive-main');

      var labelsURL = document.querySelector('#root').getAttribute('data-endpoint-labels');
      var listingURL = document.querySelector('#root').getAttribute('data-endpoint-listing');

      console.log(vm.$route.params);
      if(vm.$route.params.photometric){
        vm.$store.state.hasTutorialPlayed = true;
      }

      /*
      var beta_version = document.querySelector('.beta-version');
      if(beta_version){
        beta_version.innerText = 'beta';
        vm.checkBetaVersion();
      }
      else{
        var d = new Date();
        var n = d.getDate();
        var m = d.getMonth();
        beta_version = document.createElement('a');
        beta_version.classList.add('beta-version');
        beta_version.innerText = 'beta';
        beta_version.setAttribute('target', '_blank');
        document.querySelector('body').appendChild(beta_version);
        vm.checkBetaVersion();
      }
      */

      //Add headers for DEM server to call
      //var myHeaders = new Headers();
      //myHeaders.append("Authorization", 'Basic ' + btoa('demo:dgtnext2015'));

      //Make call for labels
      if(!vm.areLabelsLoaded){
        fetch(labelsURL, {
          credentials: "include"//,
          //headers: myHeaders
        })
          .then(function (response) {
            return response.json();
          })
          .catch(function () {
            vm.$router.push('/');
          })
          .then(function (data) {
            if (data.header.success) {
              vm.$store.state.labels = data.data;
              vm.areLabelsLoaded = true;
            }
            else {
              vm.$router.push('/');
            }
          })
          .catch(function () {
            vm.$router.push('/');
          })
          .then(function () {

            if(isMobile.any) {

              vm.checkDeviceOrientation();

              window.addEventListener("orientationchange", function () {
                vm.checkDeviceOrientation();
              });
              window.addEventListener("resize", function () {
                vm.checkDeviceOrientation();
              });

            }

            window.addEventListener("load", function () {
              var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
              if (isSafari) {
                var root = document.querySelector('html');
                root.classList = 'safari';
              }
              setTimeout(function () {
                window.scrollTo(0, 1);
              }, 0);
            });

            fetch(listingURL, {
              credentials: "include"//,
              //headers: myHeaders
            })
              .then(function (response) {
                return response.json();
              })
              .catch(function () {
                vm.$router.push('/');
              })
              .then(function (data) {
                if (data.header.success) {
                  vm.$store.state.sceneListing = data.data;
                }
                else {
                  vm.$router.push('/');
                }
              })
              .catch(function () {
                vm.$router.push('/');
              });

          });
      }

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue